import React, { useEffect, useState } from 'react';
import { inject, observer } from 'mobx-react';
import ym from 'react-yandex-metrika';
import RegWrapper from './RegWrapper';
import LoadingSpinner from '../../ui/loadingSpinner';
import RegForm from './RegForm';
import RegFormRow from './RegFormRow';
import Alert from '../../ui/alert';
import Button from '../../ui/btn';
import { getAccountData } from '../../../api/api';
import { BRANDS, browser, getLang } from '../../../common';
import { logForRegistrationDone } from '../../../logger/loggerRegForm';
import { deleteCookie } from '../../../helpers';

const Step3 = inject(
  'appStore',
  'kafkaStore',
)(
  observer((props) => {
    const {
      kafkaStore: { imprintHash },
      brandName,
      lang,
      langId,
      translationForReg,
      finishBtn,
      isNeedlog,
    } = props;

    const [wait, setWait] = useState(true);
    const [accountData, setAccountData] = useState({
      id: '',
    });
    const [errorMessages, setErrorMessages] = useState({
      formError: '',
    });
    const deleteSomeCookies = (arr) => {
      arr.forEach((item) => deleteCookie(item));
    };
    useEffect(() => {
      initAccountData();
      logForRegistrationDone(imprintHash);
    }, []);

    const initAccountData = async () => {
      const responseAccountData = await getAccountData();
      if (responseAccountData.data?.result?.login) {
        setAccountData({
          id: responseAccountData.data.result.login,
        });
        isNeedlog && ym(92925936, 'reachGoal', 'lp_promoreg_done')
      } else {
        setErrorMessages({
          ...errorMessages,
          formError: getLang(translationForReg, brandName, lang, 'serverErr'),
        });
      }
      setWait(false);
    };

    deleteSomeCookies([
      'promo_code',
      'code',
      'networkId',
      'clickId',
      'masterId',
      'partner_uid',
      'PartnerPromoCode',
    ]);

    const submitHandler = (e) => {
      e.preventDefault();
      window.location.href = `${window.location.origin}${browser().mobile ? '/m' : ''
        }/finance/deposit/create/`;

      ym('reachGoal', 'redirectBtn');
    };
    const onboardRedirect = () => {
      deleteSomeCookies([
        'promo_code',
        'code',
        'networkId',
        'clickId',
        'masterId',
        'partner_uid',
        'PartnerPromoCode',
      ]);

      setTimeout(() => {
        document.location.href = `${window.location.origin}/finance/deposit/create/`;
      }, 2500);
      ym('reachGoal', 'redirectBtn');
    };

    if (wait) return <LoadingSpinner />;

    return (
      <RegWrapper
        brandName={brandName}
        lang={lang}
        langId={langId}
        translationForReg={translationForReg}
      >
        {brandName === BRANDS.zenbet ? onboardRedirect() : ''}

        <RegForm>
          {errorMessages.formError ? (
            <RegFormRow>
              <Alert className="alert-danger" message={errorMessages.formError} />
            </RegFormRow>
          ) : (
            <>
              <RegFormRow>
                <div className="the-last-step">
                  <h1>{getLang(translationForReg, brandName, lang, 'regsuccessfull')}</h1>
                  <p style={{ marginTop: '10px', color: 'white' }}>{getLang(translationForReg, brandName, lang, 'regsuccessfulltext')}</p>
                </div>
                <div className="AccountData-Wrapper">
                  {getLang(translationForReg, brandName, lang, 'accountNumberTitle')}
                </div>
              </RegFormRow>
              <RegFormRow>
                <div className="AccountData-Wrapper">
                  <div className="AccountData-Id">{accountData.id}</div>
                </div>
              </RegFormRow>
              {!finishBtn ? (
                <RegFormRow>
                  <Button
                    id="redirectBtn"
                    className="Registration"
                    type="submit"
                    onClick={submitHandler}
                  >
                    {getLang(translationForReg, brandName, lang, 'regButtonFinalText')}
                  </Button>
                </RegFormRow>
              ) : (
                <div dangerouslySetInnerHTML={{ __html: finishBtn }} />
              )}
            </>
          )}
        </RegForm>
      </RegWrapper>
    );
  }),
);

export default Step3;
